import HelperText from 'components/HelperText';
import { Container, StyledTextarea, CharacterCounter } from './Textarea.styles';

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  value: string;
  helperText?: string;
  error?: boolean;
  maxLength?: number;
  className?: string;
}

const Textarea = ({
  value,
  helperText,
  error,
  maxLength,
  className = '',
  onChange,
  ...rest
}: TextareaProps): JSX.Element => {
  const characterCount = value.length;
  const isLimitReached = characterCount === maxLength;

  return (
    <Container>
      <StyledTextarea
        className={className}
        value={value}
        onInput={onChange}
        maxLength={maxLength}
        {...rest}
      />
      {helperText && (
        <HelperText size="sm" isError={error}>
          {helperText}
        </HelperText>
      )}
      {maxLength && (
        <CharacterCounter size="sm" isError={isLimitReached}>
          {characterCount}/{maxLength}
        </CharacterCounter>
      )}
    </Container>
  );
};

export default Textarea;
